import React, { useState } from 'react';
import { useForm } from "../../hooks/useForm/UseForm";
import { enviarReporteGoldenbeltAPI } from "../../consumers/backendApisUrls";
import { mostrarMensajeDeErrorConToast, responseCode200, responseTieneModelState } from "../../consumers/httpRequiestsUtils";
import { clearAllInputValidationMessages, mostrarMensajesDeValidacionEnCadaInput } from "../../validations/FormValidatorUtils";
import { usePostRequest } from "../../hooks/usePostRequest/usePostRequest";
import {toast} from "react-toastify";

const ReporteYTablasGoldenbelt = () => {
    const seccionName = "ReporteYTablasGoldenbelt";

    const [loading, setLoading] = useState(false);
    const [formValues, setFormValues] = useState({});

    const [handleChange] = useForm(formValues, setFormValues);
    const [executePostRequest] = usePostRequest();

    const descargarReporte = async () => {
        let payload = {
            "StartDate": formValues["StartDate"],
            "EndDate": formValues["EndDate"]
        };
        let allInputKeys = ["StartDate", "EndDate"];
        setLoading(true);
        clearAllInputValidationMessages(allInputKeys, seccionName);

        let responseReporteGenerado = await executePostRequest(enviarReporteGoldenbeltAPI(), payload);
        if (responseCode200(responseReporteGenerado)) {
            toast.success(responseReporteGenerado?.data?.Message);
        } else if (responseTieneModelState(responseReporteGenerado)) {
            mostrarMensajesDeValidacionEnCadaInput(responseReporteGenerado, allInputKeys, seccionName);
        } else {
            mostrarMensajeDeErrorConToast(responseReporteGenerado);
        }
        setLoading(false);
    }

    return (
        <>
            <div className='card-body'>
                <div id='ReporteNuevosIngresos'>
                    <div>
                        <div className="form-group row form-input-modal-contactanos reportes-label-container">
                            <label className="col-sm-2 col-form-label modal-label blue-standard-color reportes-label">Fecha Inicio<span className="required">*</span></label>
                            <div className="col-sm-4">
                                <input type="date" className="form-control" name="StartDate" onChange={handleChange}></input>
                                <p className="ficha-form-input-validation-message" id={`ficha-edit-${seccionName}-StartDate-validation-message`}></p>
                            </div>
                        </div>
                        <div className="form-group row form-input-modal-contactanos reportes-label-container">
                            <label className="col-sm-2 col-form-label modal-label blue-standard-color reportes-label">Fecha Fin<span className="required">*</span></label>
                            <div className="col-sm-4">
                                <input type="date" className="form-control" name="EndDate" onChange={handleChange}></input>
                                <p className="ficha-form-input-validation-message" id={`ficha-edit-${seccionName}-EndDate-validation-message`}></p>
                            </div>
                        </div>
                    </div>

                    <div className="reporte-datos-generales-dato-obligatorio">
                        <p>(<span className="required ">*</span>) Dato obligatorio</p>
                    </div>

                    <div>
                        <button className="btn btn-primary generic-button-ficha" onClick={descargarReporte} disabled={loading}>{loading ? 'Procesando' : 'Enviar'} Reporte {loading ? '...' : ''}</button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ReporteYTablasGoldenbelt;